const initialState = {};

export default function countrySlice(state = initialState, action) {
  return state;
}
